import { Reveal, SectionHeading } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do I need to buy a domain or hosting?",
    a: "No. Hosting, SSL, and maintenance are included in every plan. If you already own a domain we connect it for free; if not, we register one for you at cost.",
  },
  {
    q: "How does the AI voice agent get a phone number?",
    a: "We provision a dedicated local number for your agent. You can forward your existing line to it (full-time, after-hours only, or when you're busy) — your current number stays exactly as it is.",
  },
  {
    q: "Will callers know they're talking to an AI?",
    a: "The agent introduces itself transparently as your business's virtual assistant, then handles the call naturally. In our deployments, over 90% of callers complete their booking without asking for a human.",
  },
  {
    q: "How accurate is the AI with my prices and services?",
    a: "Your agent is trained only on data you approve — services, pricing, hours, policies — and says 'let me have the team confirm that' instead of guessing. You review every answer source before launch.",
  },
  {
    q: "Is there a contract or lock-in?",
    a: "No contracts. Plans are month-to-month (or annual for two months free) and you can cancel anytime. Your website content and call transcripts remain exportable.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-36 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          testId="faq-heading"
          kicker="Questions"
          title="Everything owners ask us"
        />
        <Reveal delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="glow-card rounded-2xl border px-6 sm:px-8 overflow-hidden"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-6 text-left font-display text-base sm:text-lg font-semibold text-slate-100 hover:text-cyan-300 hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm sm:text-base text-slate-400 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
